import { Renderer_Order } from './Renderer_Order.js';
import { ICONS } from '@app/styles';
import { capitalizeFirstLetter, MUSTNeverHappenException } from '@nu-art/ts-common';
import { stopPropagation } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_RuntimeProtocol } from '@app/advisor-frontend';
import { ModuleFE_ProtocolInteraction } from '../../../../_enum.js';
export class Renderer_Order_Disposition extends Renderer_Order {
    __onProtocolInteraction = () => {
        const dispositionData = ModuleFE_ProtocolInteraction.getDispositionData();
        return this.setState({
            hide: this.state.protocolId === dispositionData?.protocolId && dispositionData.type === this.state.order
        });
    };
    deriveStateFromProps(nextProps, state) {
        state.protocolId = nextProps.protocolId;
        state.order = nextProps.order;
        state.hide ??= false;
        return state;
    }
    /**
     * Validate if the dispo order is the recommended order by the protocol
     */
    isRecommendedAction = () => {
        const protocol = ModuleFE_RuntimeProtocol.cache.unique(this.state.protocolId);
        if (!protocol)
            throw new MUSTNeverHappenException(`cannot find rt protocol with id ${this.state.protocolId}`);
        return protocol.status?.includes(this.state.order);
    };
    onOrderClick = async (e) => {
        stopPropagation(e);
        // first create an up-to-date smart note summery
        // await ModuleFE_RuntimeSmartDoc._v1.createSmartDocSummary({}).executeSync();
        // then open the dispo form
        return ModuleFE_ProtocolInteraction.openDisposition(this.state.order, this.state.protocolId);
    };
    getOrderIcon = () => {
        if (this.state.order === 'admit')
            return ICONS.advisor_avn_admit;
        return ICONS.advisor_avn_discharge;
    };
    getOrderLabel = () => {
        return capitalizeFirstLetter(this.state.order);
    };
    getVariant = () => {
        return this.isRecommendedAction() ? 'order-dispo-recommended' : 'order-dispo-non-recommended';
    };
}
//# sourceMappingURL=Renderer_Order_Disposition.js.map